/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Plans_HeadingInputs */

const en_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium plans`)
};

const id_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Premium`)
};

const ms_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelan premium`)
};

const ca_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans Premium`)
};

const cs_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prémiové plány`)
};

const da_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-abonnementer`)
};

const de_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-Pakete`)
};

const et_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasulised plaanid`)
};

const es_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripciones prémium`)
};

const fr_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements Premium`)
};

const hr_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium pretplate`)
};

const it_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piani premium`)
};

const lv_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium plāni`)
};

const lt_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Premium“ planai`)
};

const hu_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prémium előfizetési csomagok`)
};

const nl_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-abonnementen`)
};

const nb_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-abonnementer`)
};

const pl_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usługi Premium`)
};

const pt_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planos Premium`)
};

const ro_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planuri Premium`)
};

const sk_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prémiové plány`)
};

const sl_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načrti Premium`)
};

const fi_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-tilaukset`)
};

const sv_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-planer`)
};

const vi_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói cao cấp`)
};

const tr_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium planlar`)
};

const el_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium προγράμματα`)
};

const bg_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум планове`)
};

const ru_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум-планы`)
};

const sr_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премијум пакети`)
};

const uk_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преміум-плани`)
};

const ka_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`პრემიუმ გამოწერები`)
};

const hi_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीमियम प्लान्स`)
};

const th_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็กเกจพรีเมียม`)
};

const ko_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 플랜`)
};

const zh_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium 套餐`)
};

const zh_tw_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高級版方案`)
};

const ja_premium_plans_heading = /** @type {(inputs: Premium_Plans_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアムプラン`)
};

/**
* | output |
* | --- |
* | "Premium plans" |
*
* @param {Premium_Plans_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const premium_plans_heading = /** @type {((inputs?: Premium_Plans_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Plans_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_premium_plans_heading(inputs)
	if (locale === "ms") return ms_premium_plans_heading(inputs)
	if (locale === "ca") return ca_premium_plans_heading(inputs)
	if (locale === "cs") return cs_premium_plans_heading(inputs)
	if (locale === "da") return da_premium_plans_heading(inputs)
	if (locale === "de") return de_premium_plans_heading(inputs)
	if (locale === "et") return et_premium_plans_heading(inputs)
	if (locale === "es") return es_premium_plans_heading(inputs)
	if (locale === "fr") return fr_premium_plans_heading(inputs)
	if (locale === "hr") return hr_premium_plans_heading(inputs)
	if (locale === "it") return it_premium_plans_heading(inputs)
	if (locale === "lv") return lv_premium_plans_heading(inputs)
	if (locale === "lt") return lt_premium_plans_heading(inputs)
	if (locale === "hu") return hu_premium_plans_heading(inputs)
	if (locale === "nl") return nl_premium_plans_heading(inputs)
	if (locale === "nb") return nb_premium_plans_heading(inputs)
	if (locale === "pl") return pl_premium_plans_heading(inputs)
	if (locale === "pt") return pt_premium_plans_heading(inputs)
	if (locale === "ro") return ro_premium_plans_heading(inputs)
	if (locale === "sk") return sk_premium_plans_heading(inputs)
	if (locale === "sl") return sl_premium_plans_heading(inputs)
	if (locale === "fi") return fi_premium_plans_heading(inputs)
	if (locale === "sv") return sv_premium_plans_heading(inputs)
	if (locale === "vi") return vi_premium_plans_heading(inputs)
	if (locale === "tr") return tr_premium_plans_heading(inputs)
	if (locale === "el") return el_premium_plans_heading(inputs)
	if (locale === "bg") return bg_premium_plans_heading(inputs)
	if (locale === "ru") return ru_premium_plans_heading(inputs)
	if (locale === "sr") return sr_premium_plans_heading(inputs)
	if (locale === "uk") return uk_premium_plans_heading(inputs)
	if (locale === "ka") return ka_premium_plans_heading(inputs)
	if (locale === "hi") return hi_premium_plans_heading(inputs)
	if (locale === "th") return th_premium_plans_heading(inputs)
	if (locale === "ko") return ko_premium_plans_heading(inputs)
	if (locale === "zh") return zh_premium_plans_heading(inputs)
	if (locale === "zh-tw") return zh_tw_premium_plans_heading(inputs)
	if (locale === "ja") return ja_premium_plans_heading(inputs)
	return en_premium_plans_heading(inputs)
});